<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-form ref="query" :model="query" inline>
        <el-form-item prop="fDistributorID" label="经销商">

          <el-select-table
            v-model="query.fDistributorID"
            :label.sync="fNumber"
            search-key="name"
            url="BasicInformation/Distributor/DistributorChoiceEntry"
            label-field="fName"
            value-field="fid"
            size="small"
            :extra-param="{prohibit:false}"
            panel-width="500px"
            :columns="[
              { prop: 'fNumber', label: '编码' },
              { prop: 'fName', label: '名称' },

            ]"
          />
        </el-form-item>
        <el-form-item prop="fStockID" label="仓库">
          <el-select
            v-model="query.fStockID"
            style="width: 200px"
            size="small"
            clearable
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in stockList"
              :key="item.fStockID"
              :value="item.fStockID"
              :label="item.fName"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="fICItemID" label="产品">
          <el-select-table
            v-model="query.fICItemID"
            :label.sync="fName"
            url="ICItemManage/ICItem/ChoiceICItemEntry"
            label-field="fName"
            value-field="ficItemID"
            size="small"
            :extra-param="{prohibit:false}"
            panel-width="500px"
            :columns="[
              { prop: 'fNumber', label: '编码' },
              { prop: 'fName', label: '名称' },
              { prop: 'fModel', label: '规格' },
              { prop: 'fUnit', label: '单位' },
            ]"
          />
        </el-form-item>
        <el-form-item prop="startDate" label="日期">
          <el-date-picker
            v-model="query.startDate"
            type="date"
            placeholder="选择日期"
            style="width: 150px"
            size="small"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item prop="endDate" label="至">
          <el-date-picker
            v-model="query.endDate"
            type="date"
            placeholder="选择日期"
            style="width: 150px"
            value-format="yyyy-MM-dd"
            size="small"
          />
        </el-form-item>
      </el-form>

      <el-button
        type="primary"
        size="small"
        style="margin-right: 10px"
        @click="refresh"
      >查询</el-button>
      <el-button-export
        v-if="candown"
        :url="downloadUrl"
        type="primary"
        size="small"
        style=""
      >下载报表</el-button-export>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
      >
        <el-table-column prop="fNumber" label="产品编码" />
        <el-table-column prop="fName" label="产品名称" />
        <el-table-column prop="fModel" label="规格" />
        <el-table-column prop="fUnit" label="单位" />
        <el-table-column prop="fQty" label="数量" />
        <el-table-column
          prop="fDate"
          label="出仓日期"
          :formatter="dateFormat"
        />
        <el-table-column prop="fBillNo" label="出仓单号" />
        <el-table-column prop="fStock" label="所属仓库" />
      </el-table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  data() {
    return {
      query: {
        fDistributorID: null,
        fStockID: null,
        fICItemID: null,
        startDate: null,
        endDate: null
      },
      fName: '',
      fNumber: '',
      stockList: [],
      ICItemList: [],
      tableData: [],
      loading: false,
      currentEditItem: null,
      candown: true
    }
  },
  mounted() {
    this.getStockEntry()
    const newtime = moment(new Date()).format('YYYY-MM-DD')
    this.query.startDate = newtime
    this.query.endDate = newtime
    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == '006002002') {
        this.candown = val.isGrant
      }
    })
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('Report/OutStockReport', this.query)
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }
          this.tableData = res.datalist
          this.pageRecordTotal = res.datalist.total
        })
        .finally(() => (this.loading = false))
    },

    getStockEntry() {
      this.$httpPost('Warehouse/Stock/StockEntry', {}).then((res) => {
        if (!res.isSuccess) {
          this.$message.error(res.message)
          return
        }
        this.stockList = res.datalist
      })
    },
    getICItemEntry() {
      this.$httpPost('ICItemManage/ICItem/ChoiceICItemEntry', {
        prohibit: false
      }).then((res) => {
        if (!res.isSuccess) {
          this.$message.error(res.message)
          return
        }
        this.ICItemList = res.datalist
      })
    },
    downloadUrl: function() {
      const req = this.query
      return this.$buildDownloadUrl(
        'LogisticsSystemApi/Report/OutStockReportDownload',
        { ...req }
      )
    },
    dateFormat: function(row, column, cellValue) {
      var date = cellValue
      if (date == undefined) {
        return ''
      }
      return moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>
<style scoped lang='less'>
.query-bar {
}
</style>
